import { keys } from "./Keys";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { useQuery } from "react-query";
import { ISummaryDTO } from "../../services/alarm-scheme-data-service/Models";
import AlarmSchemeAdministrationDataService from "../../services/alarm-scheme-data-service/AlarmSchemeAdministrationService";

export type UseGetAlarmSchemesParams = {
    organizationID: number,
    groupID: number,
} & BaseUseQueryParameters<ISummaryDTO[] | undefined>;

export function useGetAlarmSchemes({
    organizationID,
    groupID,
    enabled,    
    onSuccess,
    onError
}: UseGetAlarmSchemesParams) {
    return useQuery<ISummaryDTO[], RestError>(
        keys.alarmSchemes(organizationID, groupID),
        ({ signal }) => {
            return AlarmSchemeAdministrationDataService.getAlarmSchemes(
                organizationID,
                groupID,
                signal
            );
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            refetchInterval: false,
            staleTime: Infinity,
            refetchOnWindowFocus: false,
            refetchOnMount: true,
            refetchOnReconnect: false,
            retry: false,
        }
    );
}